import { useEffect, useRef } from 'react';

/**
 * EmojiPicker — 의존성 없는 경량 이모지 팝오버 (자주 쓰는 이모지 그리드).
 *
 * MessageInput 의 Smile 버튼이 토글. 선택 시 onSelect(emoji) 로 textarea 커서 위치 삽입.
 * 외부 클릭/Esc 로 닫힘. 풀 카테고리 피커는 후속(라이브러리 도입 시점) — 현재는 코어 40종.
 */

const EMOJIS = [
  '😀', '😁', '😂', '🤣', '😊', '😍', '😉', '😎',
  '🤔', '😅', '😴', '😢', '😭', '😡', '🥳', '😱',
  '👍', '👎', '👏', '🙏', '💪', '🙌', '🤝', '👀',
  '❤️', '🔥', '✨', '🎉', '💯', '💡', '🚀', '⭐',
  '✅', '❌', '⚠️', '📌', '📎', '🕐', '😇', '🤗',
];

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
  onClose: () => void;
}

export function EmojiPicker({ onSelect, onClose }: EmojiPickerProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    }
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    // capture 단계 — 토글 버튼 자신의 click 으로 즉시 닫히지 않게 다음 tick 에 등록.
    const id = window.setTimeout(() => {
      document.addEventListener('mousedown', onDocClick);
      document.addEventListener('keydown', onKey);
    }, 0);
    return () => {
      window.clearTimeout(id);
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div ref={ref} className="chat-emoji-picker" role="dialog" aria-label="이모지 선택">
      <div className="chat-emoji-picker-grid">
        {EMOJIS.map((emoji) => (
          <button
            key={emoji}
            type="button"
            className="chat-emoji-picker-item"
            onClick={() => onSelect(emoji)}
            aria-label={emoji}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
}
